// TODO: this will turn into a component (component file) and be served from the backend (compiled on server side and then included dynamically in the app
// NOTE: we can keep a base and use the mixins option to extend it with code from the backend https://vuejs.org/v2/api/#mixins

// This is a factory function for a dynamic component. The dynamic nature, in this case, means that the template is
//  dynamic (contained in the data parameter and comes from the server side). We may not need this, though we still
//  need some kind of generic factory mechanism (that distinguishes based on the data type) in the parent component.
//  Or maybe not, since we just have a fixed (and small) number of components, so we could just include them all and
//  switch between them. **A design review is needed**.

// import voca from 'voca'
import base from './component-base'
import store from '@/store'

// TODO: this can now be changed into a proper vue component (probably) with a dinamic component for the template

import ChoiceHorizontal from './questions/ChoiceHorizontal' // 1
import ChoiceVertical from './questions/ChoiceVertical' // 5
import DataQuestion from './questions/DataQuestion' // 12
import GraphicChoicesHorizontal from './questions/GraphicChoicesHorizontal' // 7
import IconChoiceBoolean from './questions/IconChoiceBoolean' // 11
import KeyboardingQuestionSingleLine from './questions/KeyboardingQuestionSingleLine' // 3
import LikertScaleHorizontal from './questions/LikertScaleHorizontal' // 8
import LikertScaleIcons3 from './questions/LikertScaleIcons3' // 13
import LikertScaleSupervisorRating7 from './questions/LikertScaleSupervisorRating7' // 9
import ProofingInformationHorizontal from './questions/ProofingInformationHorizontal' // 6
import RememberingInformation from './questions/RememberingInformation' // 2
import RichChoiceHorizontal from './questions/RichChoiceHorizontal' // 10
import StyledLikertScale from './questions/StyledLikertScale' // 14
import VerifyingDataHorizontal from './questions/VerifyingDataHorizontal' // 4

// SkillsBuild TechTypes
import TechTypesLikertScale from '@/branding/ibm_skillsbuild/techtypes/components/questions/LikertScale.vue' // 15

import LoadingPlaceholder from './questions/LoadingPlaceholder'

import Vue from 'vue'

const TEMPLATE_MAP = {
  '-1': LoadingPlaceholder,
  1: ChoiceHorizontal,
  2: RememberingInformation,
  3: KeyboardingQuestionSingleLine,
  4: VerifyingDataHorizontal,
  5: ChoiceVertical,
  6: ProofingInformationHorizontal,
  7: GraphicChoicesHorizontal,
  8: LikertScaleHorizontal,
  9: LikertScaleSupervisorRating7,
  10: RichChoiceHorizontal,
  11: IconChoiceBoolean,
  12: DataQuestion,
  13: LikertScaleIcons3,
  14: StyledLikertScale,
  1000: TechTypesLikertScale
}

export default function (data) {
  console.debug('> Create group: ')
  const loadTimestamp = new Date().getTime()

  return {
    mixins: [base],
    data () {
      console.debug('>> Initializing group data [loadTimestamp = ', loadTimestamp)
      // this.$parent.showFinish = !data.next && data.content.allowNext

      // this.$parent.showNext = !!data.next && data.content.allowNext
      // this.$parent.showPrev = !!data.previous && data.content.allowPrev

      // return {
      //   questions: data.questions
      // }
      const d = Object.assign({}, data.content)
      d.store = store

      // We don't really need these two guys here. (It's unlike insider trading in a ly we could just receive data.content and be fine)
      d.next = data.next
      d.previous = data.previous

      d.show = true

      d.startTimestamp = loadTimestamp - d.elapsed * 1000
      d.currentTime = loadTimestamp
      d.autoSubmitAt = d.startTimestamp + (d.timeLimit * 1000 || Number.POSITIVE_INFINITY)
      d.isTimed = d.timeLimit != null

      // We want to show that the test(run) is completed even before submitting a response to the last question
      //  (this can be problematic, though, because navigating back means submitting the current question so that
      //  will advance the counter - we may have to correct for this elsewhere)
      d.test.progress.completed = Math.min(d.test.progress.completed + d.questions.length, d.test.progress.total)
      store.progress = d.test.progress

      // Display timer component if there is a time limit for the test (ignores group time limits)
      d.displayTimer = d.test.timeLimit != null
      console.debug('--', d.autoSubmitAt, loadTimestamp, d.timeLimit, d.timeLimit * 1000 || Number.POSITIVE_INFINITY, (d.timeLimit * 1000) || Number.POSITIVE_INFINITY)
      return d
    },
    render (...args) {
      // return (new (Vue.extend(TEMPLATE_MAP[this.templateId]))()).$options.render(...args);
      return this.renderDelegate(...args)
    },
    methods: {
      // TODO: content should probably be 'push' -> set by the template
      getResponses () {
        return this.questions.map((question, index) => {
          return {
            id: question.id,
            content: question.response
          }
        })
      },
      tick () {
        this.currentTime = new Date().getTime()
        this.store.timer.time = this.countdown
        // console.log('Tick', this.store.timer.time, this.autoSubmitAt, this.currentTime);

        if (this.autoSubmitAt <= this.currentTime) {
          console.debug('Emit autoSubmit')

          // Auto submit once...
          this.autoSubmitAt = Number.NaN
          this.$parent.$emit('autoSubmit', { elementUid: this.elementUid, testId: this.test.id })
        }
      },
      randint (a, b) {
        if (!b) {
          b = a
          a = 0
        }

        return Math.floor(Math.floor(Math.random() * (b - a)) + a)
      },
      handleInputCompleted () {
        console.debug('group> handleInputCompleted . Responses = ', JSON.stringify(this.getResponses()))
        console.debug('group> handleInputCompleted - emitting')
        this.$parent.$emit('inputCompleted')
      }
    },
    directives: {
      // NOTE: This is useful only as long as there is one question on the page. (We should probably
      // automatically focus the first input element from here...
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    },
    computed: {
      timer () {
        return Math.round((this.currentTime - this.startTimestamp) / 1000)
      },
      countdown () {
        return Math.max(0, this.timeLimit - this.timer)
      },
      // TODO: this is only needed for Remembering information. Maybe doing it on the server side (in the serializer) would be a better option
      shuflledQuestions () {
        const shuffle = () => {
          const shuffled = this.questions.slice(0)

          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = this.randint(shuffled.length);
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
          }

          // return this.questions
          return shuffled
        }

        // TODO: this is very specific to Remembering information (and even hackish). Would be nicer if we could trigger re-shuffling from the template
        return {
          true: Object.assign([], shuffle()),
          false: Object.assign([], shuffle())
        }
      },
      needsSubmit () {
        return true
      },
      allAnswered () {
        return this.getResponses().reduce((acc, v) => {
          return acc && (v.content !== null && v.content !== '')
        }, true)
      },
      userCanFinish () {
        // Whether to display a Submit button when displaying this component as the last one
        return !this.isTimed
      },
      templateId () {
        try {
          console.log('templateId', data.content.template || -1)
          return data.content.template || -1
        } catch (e) {
          console.log('-> templateId', -1)
          return -1
        }
      },
      renderDelegate () {
        // TODO: add template and make this instead a dynamic component -> method access?
        console.debug('Render delegate')
        return (new (Vue.extend(TEMPLATE_MAP[this.templateId]))()).$options.render
      }
    },
    mounted () {
      const inputs = document.getElementsByTagName('input')
      console.debug('> group ' + this.elementUid + ' mounted')
      for (const input of inputs) {
        // TODO: control this through a data- attribute instead
        if (input.type === 'text') {
          input.focus()
          break
        }
      }
      // TODO: move tooltip support to LikertScaleSupervisorRating7, where it belongs
      // global.$('[data-toggle="tooltip"]').tooltip()
    }
    // destroyed () {
    //   // TODO: move tooltip support to LikertScaleSupervisorRating7, where it belongs
    //   global.$('[data-toggle="tooltip"]').tooltip('dispose')
    // }
  }
}
